export const titulos = [
  "Alergólogo",
  "Algólogo",
  "Anestesiólogo",
  "Angiólogo",
  "Cardiólogo",
  "Endocrinólogo",
  "Estomatólogo",
  "Farmacólogo clínico",
  "Foniatra",
  "Gastroenterólogo",
  "Genetista",
  "Geriatra",
  "Hematólogo",
  "Hepatólogo",
  "Infectólogo",
  "Inmunólogo",
  "Médico aeroespacial",
  "Médico deportólogo",
  "Médico familiar",
  "Fisiatra",
  "Médico forense",
  "Intensivista",
  "Internista",
  "Médico paliativista",
  "Médico salubrista",
  "Médico del trabajo",
  "Nefrólogo",
  "Neumólogo",
  "Neurólogo",
  "Nutriólogo",
  "Oncólogo",
  "Radioterapeuta",
  "Pediatra",
  "Psiquiatra",
  "Reumatólogo",
  "Toxicólogo",
  "Cirujano cardíaco",
  "Cirujano craneofacial",
  "Cirujano general",
  "Cirujano maxilofacial",
  "Cirujano oncólogo",
  "Cirujano ortopédico",
  "Cirujano pediátrico",
  "Cirujano plástico",
  "Cirujano torácico",
  "Cirujano vascular",
  "Coloproctólogo",
  "Neurocirujano",
  "Dermatólogo",
  "Ginecólogo obstetra",
  "Médico emergenciólogo",
  "Odontólogo",
  "Oftalmólogo",
  "Otorrinolaringólogo",
  "Traumatólogo ortopedista",
  "Urólogo",
  "Especialista en análisis clínico",
  "Anatomopatólogo",
  "Bioquímico clínico",
  "Embriólogo",
  "Farmacólogo",
  "Genetista médico",
  "Médico nuclear",
  "Microbiólogo",
  "Neurofisiólogo clínico",
  "Radiólogo",
  "Administrador de salud",
  "Auditor médico",
  "Epidemiólogo",
  "Salubrista",
];
